import { render, staticRenderFns } from "./RequestCredit.vue?vue&type=template&id=13c39f5d"
import script from "./RequestCredit.vue?vue&type=script&lang=js"
export * from "./RequestCredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports